/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCto } from '../../models/company-cto';

export interface GetCompanies$Plain$Params {
  Name?: string;
  CompanyGuid?: string;
  CompanyId?: number;
  ApiCompanyId?: string;
}

export function getCompanies$Plain(http: HttpClient, rootUrl: string, params?: GetCompanies$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanies$Plain.PATH, 'get');
  if (params) {
    rb.query('Name', params.Name, {});
    rb.query('CompanyGuid', params.CompanyGuid, {});
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('ApiCompanyId', params.ApiCompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCto>>;
    })
  );
}

getCompanies$Plain.PATH = '/company/search';
